var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 1.33338H5.99998C2.66665 1.33338 1.33331 2.66671 1.33331 6.00005V10C1.33331 13.3334 2.66665 14.6667 5.99998 14.6667H9.99998C13.3333 14.6667 14.6666 13.3334 14.6666 10V8.66671M9.93998 2.76671C10.3866 4.36005 11.6333 5.60671 13.2333 6.06005M10.6933 2.01338L5.43998 7.26671C5.23998 7.46671 5.03998 7.86005 4.99998 8.14671L4.71331 10.1534C4.60665 10.88 5.11998 11.3867 5.84665 11.2867L7.85331 11C8.13331 10.96 8.52665 10.76 8.73331 10.56L13.9866 5.30671C14.8933 4.40005 15.32 3.34671 13.9866 2.01338C12.6533 0.680046 11.6 1.10671 10.6933 2.01338Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.854167ba141012d683e738bf996be2a2.svg";
export { ForwardRef as ReactComponent };